<template>
  <div>
    <div v-if="!devicecategory" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <app-header :title="devicecategory.name" :subtitle="'Device Category #' + devicecategory.id">
        <b-button
          v-router-link="{ name: 'devicecategory-editor', query: { id: devicecategory.id } }"
          variant="primary"
        >
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Device Category
        </b-button>
      </app-header>
      <b-container>
        <b-tabs>
          <!--profileTab-->
          <b-tabs title="Profile" class="mt-3"> </b-tabs>
        </b-tabs>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from "@/services/api";
import AppHeader from "@/components/AppHeader";

export default {
  components: {
    AppHeader
  },

  data() {
    return {
      query: "",
      devicecategory: null
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.devicecategory = await $api.get(
        `/v1/internal/devicecategories/${this.$route.params.id}`
      );
    }
  }
};
</script>
